import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('credit-processes-documents', storeModule.createStoreModule('credit-processes-documents'))
